import { Box } from '@cmg/design-system';
import defaultTo from 'lodash/defaultTo';
import React from 'react';

import { SidePanelTitle } from '../../components/side-bar/components/design-system';
import { useSupersededOfferingContext } from '../../contexts/SupersededOfferingContext';
import { useOfferingSidePanelOfferingId } from '../../hooks/useOfferingSidePanelMatch';
import { getAttestationStatus } from '../compliance/context/hooks/certificates/Certificates.model';
import IndicationComplianceWarningWrapper from './compliance/IndicationComplianceWarningWrapper';
import IndicationFormEmptyState from './components/indication-form-empty-state/IndicationFormEmptyState';
import ComplianceErrorBanner from './components/manage-indication/common/compliance-required-banner/ComplianceErrorBanner';
import {
  IndicationActivityBuySideContextProvider,
  useIndicationActivityBuySideContext,
} from './context/IndicationActivityBuySideContext';
import IndicationActivityBuySide from './IndicationActivityBuySide';

const IndicationActivityBuySideComponent: React.FC = () => {
  const {
    complianceWarning,
    basicPublishedOffering,
    loading,
    attestation,
    certificateType,
    orderBookConfiguration,
  } = useIndicationActivityBuySideContext();
  const indication = basicPublishedOffering?.myInstitutionalIndication;

  return (
    <Box>
      {!!basicPublishedOffering && (
        <ComplianceErrorBanner
          offeringType={defaultTo(basicPublishedOffering?.type, null)}
          isMissingContacts={false}
          attestationStatus={
            complianceWarning?.hasComplianceWarning ? getAttestationStatus(attestation) : undefined
          }
          interestLevels={indication?.interestLevels ?? []}
          isLimitIndicationsOnlyEnabled={orderBookConfiguration?.isLimitIndicationsOnlyEnabled}
          isIndicationPriceAsPercentageParEnabled={
            orderBookConfiguration?.isIndicationPriceAsPercentageParEnabled
          }
          certificateType={certificateType}
          isOnlySharesUnitOnIndicationsEnabled={
            orderBookConfiguration.isOnlySharesUnitOnIndicationsEnabled
          }
        />
      )}
      <IndicationComplianceWarningWrapper
        complianceWarning={complianceWarning}
        indicationExists={!!basicPublishedOffering?.myInstitutionalIndication}
        loading={loading}
        attestation={attestation}
        certificateType={certificateType}
      >
        <IndicationActivityBuySide />
      </IndicationComplianceWarningWrapper>
    </Box>
  );
};

const IndicationActivityBuySideRoute: React.FC = () => {
  const offeringId = useOfferingSidePanelOfferingId();
  const { isFiledOffering } = useSupersededOfferingContext();

  return (
    <IndicationActivityBuySideContextProvider offeringId={offeringId}>
      <SidePanelTitle>Communicated Demand</SidePanelTitle>
      {!isFiledOffering ? <IndicationActivityBuySideComponent /> : <IndicationFormEmptyState />}
    </IndicationActivityBuySideContextProvider>
  );
};

export default IndicationActivityBuySideRoute;
